(() => {
  if (!customElements.get('ht-shell-header')) {
    customElements.define('ht-shell-header', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        document.addEventListener('pointerdown', () => { this.dataset.shellInputModality = 'pointer'; }, { signal, capture: true });
        document.addEventListener('keydown', event => {
          if (!event.altKey && !event.ctrlKey && !event.metaKey && !['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) this.dataset.shellInputModality = 'keyboard';
        }, { signal, capture: true });
        const menu = this.querySelector('[data-shell-menu]');
        const trigger = this.querySelector('[data-shell-menu-open]');
        const close = () => {
          if (menu?.open) menu.close();
          trigger?.setAttribute('aria-expanded', 'false');
        };
        trigger?.addEventListener('click', () => {
          menu?.showModal();
          trigger.setAttribute('aria-expanded', 'true');
          menu?.querySelector('[data-shell-menu-close]')?.focus({ preventScroll: true });
        }, { signal });
        this.querySelector('[data-shell-menu-close]')?.addEventListener('click', close, { signal });
        menu?.addEventListener('close', () => {
          trigger?.setAttribute('aria-expanded', 'false');
          trigger?.focus({ preventScroll: true });
        }, { signal });
        menu?.addEventListener('click', event => {
          if (event.target !== menu) return;
          const bounds = menu.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
        }, { signal });
        this.querySelector('[data-shell-promo-close]')?.addEventListener('click', () => {
          this.querySelector('[data-shell-promo]').hidden = true;
        }, { signal });
        const search = this.querySelector('[data-shell-search-dialog]');
        const searchTrigger = this.querySelector('[data-shell-search-open]');
        searchTrigger?.addEventListener('click', () => {
          search?.showModal();
          searchTrigger.setAttribute('aria-expanded', 'true');
          search?.querySelector('[data-ht-search-input]')?.focus({ preventScroll: true });
        }, { signal });
        this.querySelector('[data-shell-search-close]')?.addEventListener('click', () => search?.close(), { signal });
        search?.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          event.stopPropagation();
          search.close();
        }, { signal });
        search?.addEventListener('close', () => {
          searchTrigger?.setAttribute('aria-expanded', 'false');
          searchTrigger?.focus({ preventScroll: true });
        }, { signal });
        search?.addEventListener('click', event => {
          if (event.target !== search) return;
          const bounds = search.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) search.close();
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  const setupFooter = scope => {
    scope.querySelectorAll('.ht-shell-footer').forEach(footer => {
      if (footer.dataset.shellReady) return;
      footer.dataset.shellReady = 'true';
      const faq = document.querySelector('[id^="ArcadeFAQ-"], [id^="StandaloneFaqTitle-"]');
      if (faq) {
        footer.querySelector('[data-shell-faq-link]').href = `#${faq.id}`;
        footer.querySelector('[data-shell-faq-item]').hidden = false;
      }
      const desktop = matchMedia('(min-width: 990px)');
      const groups = [...footer.querySelectorAll('[data-shell-footer-group]')];
      const sync = () => groups.forEach(group => {
        group.open = desktop.matches;
        group.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
      });
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
        if (desktop.matches) event.preventDefault();
      }));
      desktop.addEventListener('change', sync);
      sync();
    });
  };
  setupFooter(document);
  document.addEventListener('shopify:section:load', event => setupFooter(event.target));
})();
